import * as React from 'react';

interface IProps {
  label: any,
  value: any,
  placeholder?: string,
  icon?: string,
  dataField: string,

  changeCallback: (e: React.FormEvent<HTMLInputElement>, field: string) => void
}

export const TextInputSmall: React.SFC<IProps> = props => {
  return (
      <div className="field" style={{marginBottom: ".25rem"}}>
      {props.label !== "" && <label className="label">{props.label}</label>}
        <div className={(props.icon) ? "control has-icons-left" : "control"}>
          <input
            onChange={(event: React.FormEvent<HTMLInputElement>) => props.changeCallback(event, props.dataField)} // tslint:disable-line
            type="text"
            className="input is-small"
            placeholder={(props.placeholder) ? props.placeholder : "Please enter text here"}
            required={false}
            value={props.value}
            />
          {
            (props.icon)
            ? (<span className="icon is-small is-left"><i className={"fa " + props.icon} /></span>)
            : ''
            }

        </div>
      </div>
  )
};



// WEBPACK FOOTER //
// ./src/Containers/generators/EditGenerator/input/TextInputSmall.tsx